// /******* PRODUCCION *******/
export const environment = {
  production: false,
  apiGatewayAddress: "https://wsgatewaysigo.pvn.gob.pe",
  apiGatewayTransversal: "https://wsgatewaysigo.pvn.gob.pe",
  loginUrl: 'https://webseguridad.pvn.gob.pe/loginPortal?ReturnUrl=',
  loginOut: 'https://webseguridad.pvn.gob.pe/loginPortal?ReturnUrl=',
  loginSigo: "https://webseguridad.pvn.gob.pe/loginSigo?ReturnUrl=",
  loginOutSIGO: "https://webseguridad.pvn.gob.pe/loginPortal?ReturnUrl=",
  identidadesUrl: "https://identidades.pvn.gob.pe",
  identidadesSeguridadUrl: "ApiSeguridadV2",
  idpClientId: "bdc2e34d-6df9-42f6-9c36-66bb7a1934cc",
  idpClientRoot: "https://webseguridad.pvn.gob.pe",
  idpClientResources: "046e5b68-07f1-4d28-9ddd-e39fb0e1df07 85570ee3-09c2-4a20-b3d4-8a6900a2ee02 8f499424-3204-4448-a069-8e3068bfe1df",
  apiConsultaPide: "https://identidades.pvn.gob.pe/apipidev2/api",
  tipoPerfilSTS: {
    Administrador: 1157,
    Transportista: 1158,
    Certificadora: 1159,
    JefeOperaciones: 1160,
    EspecialistaOperaciones: 1161,
    NotificadorOperaciones: 1162,
    IngenieroOperaciones: 1163,
    ApoyoJefeOperaciones: 1164,
    Abogado: 1172,
  },
  urlFileServerNotificacionCasilla: "https://sigo.pvn.gob.pe/fileserver/notificaciones",
  signalRAcademicoUrl: "https://wssignalrhub"
};
